import { Box, Button, DialogActions, Link, Typography } from '@mui/material';
import React from 'react';

import DefaultModal from '../../components/Modals/DefaultModal';

interface ModalProps {
  open: boolean;
  setOpen: (e: boolean) => void;
  user: string | null;
}

export default function FeedbackModal(props: ModalProps): JSX.Element {
  const handleClose = () => props.setOpen(false);

  return (
    <DefaultModal open={props.open} handleClose={handleClose}>
      <Box sx={{ px: 6 }}>
        <Typography variant="h4" textAlign="center" color="grey.900" mb={2}>
          Password Updated
        </Typography>
        The password for {props.user} has been updated.
      </Box>
      <DialogActions sx={{ justifyContent: 'center', pb: 3 }}>
        <Link
          underline="none"
          color="inherit"
          href="https://dev-ng.allworknow.com/"
        >
          <Button>Login</Button>
        </Link>
      </DialogActions>
    </DefaultModal>
  );
}
